import CustomerQuickAdd from './components/CustomerQuickAdd.vue'
import SuppliersQuickAdd from './components/SuppliersQuickAdd.vue'
import PurchaseCategoryQuickAdd from './components/PurchaseCategoryQuickAdd.vue'

import ProductsLineQuickAdd from './components/ProductsLineQuickAdd.vue'
import ProductsSubLineQuickAdd from './components/ProductsSubLineQuickAdd.vue'
import ProductsCategoryQuickAdd from './components/ProductsCategoryQuickAdd.vue'
import ProductsSubCategoryQuickAdd from './components/ProductsSubCategoryQuickAdd.vue'
import CurrencyQuickAdd from './components/CurrencyQuickAdd.vue'
import ProductsColorsQuickAdd from './components/ProductsColorsQuickAdd.vue'
import ProductsWaistQuickAdd from './components/ProductsWaistQuickAdd.vue'

import EmployeeCategoryQuickAdd from './components/EmployeeCategoryQuickAdd.vue'
import ProjectQuickAdd from './components/ProjectQuickAdd.vue'
import ActivityQuickAdd from './components/ActivityQuickAdd.vue'

import MethodsPaymentQuickAdd from './components/MethodsPaymentQuickAdd.vue'
import ConceptsQuickAdd from './components/ConceptsQuickAdd.vue'
import MethodsAcopioQuickAdd from './components/MethodsAcopioQuickAdd.vue'
import PurchaseInfoPaymentQuickAdd from './components/PurchaseInfoPaymentQuickAdd.vue'

import ServicesCategoryQuickAdd from './components/ServicesCategoryQuickAdd.vue'

const forms = {
  'customers':         CustomerQuickAdd,
  'suppliers':         SuppliersQuickAdd,
  'purchaseCategory':  PurchaseCategoryQuickAdd,

  'productsLine':        ProductsLineQuickAdd,
  'productsSubLine':     ProductsSubLineQuickAdd,
  'productsCategory':    ProductsCategoryQuickAdd,
  'productsSubCategory': ProductsSubCategoryQuickAdd,
  'currency':            CurrencyQuickAdd,
  'productsColors':      ProductsColorsQuickAdd,
  'productsWaist':       ProductsWaistQuickAdd,

  'employeeCategory':  EmployeeCategoryQuickAdd,
  'project':           ProjectQuickAdd,
  'activity':          ActivityQuickAdd,

  'erpMethodsPayment': MethodsPaymentQuickAdd,
  'concepts':          ConceptsQuickAdd,
  'erpMethodsAcopio':  MethodsAcopioQuickAdd,
  'purchaseInfoPayment': PurchaseInfoPaymentQuickAdd,

  'servicesCategory':  ServicesCategoryQuickAdd,
}

export default forms
